import { uniq } from 'lodash';

// First locale is the default locale
const locales = [
  {
    basename: '',
    countryCode: '*', // everything else
    currency: 'EUR',
    language: 'en',
    locale: 'en-GB',
    contentfulLocale: 'en-US',
  },
  {
    basename: 'us',
    countryCode: ['US'],
    currency: 'USD',
    language: 'en',
    locale: 'en-US',
    contentfulLocale: 'en-US',
  },
  {
    basename: 'ca',
    currency: 'CAD',
    countryCode: 'CA',
    language: 'en',
    locale: 'en-CA',
    contentfulLocale: 'en-US',
  },
  {
    basename: 'de',
    countryCode: ['DE', 'AT', 'LI', 'LU', 'CH'],
    currency: 'EUR',
    language: 'de',
    locale: 'de-DE',
    contentfulLocale: 'de',
  },
  {
    basename: 'fr',
    countryCode: ['FR', 'BE'],
    currency: 'EUR',
    language: 'fr',
    locale: 'fr-FR',
    contentfulLocale: 'fr',
  },
  {
    basename: 'es',
    countryCode: ['ES'],
    currency: 'EUR',
    language: 'es',
    locale: 'es-ES',
    contentfulLocale: 'es',
  },
  {
    basename: 'ko',
    countryCode: ['KR'],
    currency: 'USD',
    language: 'ko',
    locale: 'ko-KR',
    contentfulLocale: 'ko',
  },
  {
    basename: 'ja',
    countryCode: ['JP'],
    currency: 'EUR',
    language: 'ja',
    locale: 'ja-JP',
    contentfulLocale: 'ja',
  },
];

const supportedLocales = process.env.SUPPORTED_LOCALES
  ? uniq(process.env.SUPPORTED_LOCALES.split(','))
  : locales.map(l => l.locale);
const SUPPORTED_LOCALES = locales.filter(l => uniq(supportedLocales).includes(l.locale));

export default SUPPORTED_LOCALES;

const appSupportedLocales = process.env.APP_SUPPORTED_LOCALES
  ? uniq(process.env.APP_SUPPORTED_LOCALES.split(','))
  : locales.map(l => l.locale);

export const APP_SUPPORTED_LOCALES = locales.filter(l =>
  uniq(appSupportedLocales).includes(l.locale)
);

export const appSupportedBaseNames = APP_SUPPORTED_LOCALES.reduce(
  (acc, { basename }) => [...acc, basename],
  []
).filter((el, i, a) => i === a.indexOf(el));

export const ALL_LANGUAGES = uniq(locales.map(l => l.language));

export const SUPPORTED_LANGUAGES = uniq(SUPPORTED_LOCALES.map(l => l.language));

export function getLocaleByCountryCode(lookupCode) {
  return SUPPORTED_LOCALES.find(locale => locale.countryCode.indexOf(lookupCode) !== -1);
}

export const defaultLocale = getLocaleByCountryCode('*');

export const getLocaleByLanguage = language => {
  return SUPPORTED_LOCALES.find(locale => locale.language === language);
};

export const validBaseNames = SUPPORTED_LOCALES.reduce(
  (acc, { basename }) => [...acc, basename],
  []
).filter((el, i, a) => i === a.indexOf(el)); // to make unique

export function getCurrencyByCountryCode(lookupCode) {
  const locale = getLocaleByCountryCode(lookupCode);
  return (locale || defaultLocale).currency;
}



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/locales.js